import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { ClarificationRequestMachineStateDescriptor } from './model/clarification.request';

@Injectable()
export class ClarificationRequestMachineService extends RESTServiceBase {

  constructor(authService: AuthService, config: AppConfig) {
    super(
      'v1',
      'ClarificationRequestMachineManagement',
      authService,
      config.CMSConfig
    );
  }

  public async getExpectedStates(dataEntryId: string): Promise<ClarificationRequestMachineStateDescriptor[]> {
    return super.get<ClarificationRequestMachineStateDescriptor[]>(dataEntryId);
  }

  public async set(dataEntryId: string, state: ClarificationRequestMachineStateDescriptor): Promise<void> {
    return super.patch<any>(dataEntryId, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clarification.request/clarification.request.machine.service.ts